<template>
  <div>
    <div class="row align-items-center">
      <div class="col-md-8">
<!--        <a-tag color="red" v-if="data.school_id == 16 && (data.class_id == 69 || data.class_id == 70 || data.class_id == 71 || data.class_id == 72 )">
          Online fee payment is not yet available for Class 9 to 12
        </a-tag>-->
        <h5 class="font-weight-bold mb-0">{{ data.student.first_name }} {{ data.student.last_name }}</h5>
        <p>
          <span class="pr-2">Student Code:</span> <span class="font-weight-bold px-2">{{ data.student_code }}</span>|
          <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{ data.school_class ? data.school_class.name : 'Not Assigned' }}</span>|
          <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{ data.section ? data.section.name : 'Not Assigned' }}</span>|
          <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{ data.roll_no }}</span>
        </p>
      </div>
      <div class="col-md-4 text-md-right">
        <button
          type="button"
          class="btn btn-sm btn-primary btn-with-addon"
          @click="handlePayAll(data, schoolId, studentCode)"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-credit-card" />
          </span>
          Pay Multiple Fees
        </button>
      </div>
    </div>

    <hr class="m-0">

    <div class="row">
      <!-- One time Fees -->
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">One Time Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Disc.</th>
                  <th>Disc. %</th>
                  <th>Due</th>
                  <th>Total</th>
                  <!-- <th>Start Date</th> -->
                  <th>Due Date</th>
                  <th>Status</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="studentFee in getOneTimeFees(data.student_fees)"
                  :key="studentFee.id"
                >
                  <th>{{ studentFee.fee_setting.class_fee.fee.name }}</th>
                  <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                  <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
                  <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
                  <!-- <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td> -->
                  <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                  <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                  <td class="text-right">
                    <a
                      href="javascript:;"
                      :class="['p-1 mr-2 text-primary neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handlePaySingle(studentFee, schoolId, studentCode)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-credit-card" /> Pay
                    </a>
                    <a
                      href="javascript:;"
                      :class="['p-1 text-primary neo-icon-btn', `${studentFee.payment_status != 1 ? 'bg-light text-muted' : ''}`]"
                      @click="handleViewReceipt(studentFee, data)"
                      :disabled="studentFee.payment_status != 1"
                    >
                      <i class="fe fe-eye mr-2" /> Receipt
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
      <!-- Recurring Fees -->
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">Recurring Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
                <tr>
                  <th>Fees</th>
                  <th>Amount</th>
                  <th>Fine</th>
                  <th>Disc.</th>
                  <th>Disc. %</th>
                  <th>Due</th>
                  <th>Type</th>
                  <th>Total</th>
                  <!-- <th>Start Date</th> -->
                  <th>Due Date</th>
                  <th>Status</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="studentFee in getRecurringFees(data.student_fees)"
                  :key="studentFee.id"
                >
                  <th>{{ studentFee.fee_setting.class_fee.fee.name }}</th>
                  <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                  <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
                  <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>
                  <td class="font-weight-bold">{{ getFeeType(studentFee.fee_type) }}</td>
                  <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
                  <!-- <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td> -->
                  <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                  <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                  <td class="text-right">
                    <a
                      href="javascript:;"
                      :class="['p-1 mr-2 text-primary neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                      @click="handlePaySingle(studentFee, schoolId, studentCode)"
                      :disabled="studentFee.payment_status === 1"
                    >
                      <i class="fe fe-credit-card" /> Pay
                    </a>
                    <a
                      :disabled="studentFee.payment_status != 1"
                      href="javascript:;"
                      :class="['p-1 text-primary neo-icon-btn', `${studentFee.payment_status != 1 ? 'bg-light text-muted' : ''}`]"
                      @click="handleViewReceipt(studentFee, data)"
                    >
                      <i class="fe fe-eye mr-2" /> Receipt
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
      <!-- Custom Fees -->
      <div class="col-md-12">
        <div class="mt-3">
          <p class="text-muted mb-2">Custom Fees</p>
          <vue-custom-scrollbar class="scroll-area">
            <table class="table table-borderless">
              <thead class="bg-light">
              <tr>
                <th>Fees</th>
                <th>Amount</th>
                <th>Fine</th>
                <th>Disc.</th>
                <th>Disc. %</th>
                <th>Due</th>
                <th>Type</th>
                <th>Total</th>
                <!-- <th>Start Date</th> -->
                <th>Due Date</th>
                <th>Status</th>
                <th class="text-right">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="studentFee in getIndividualFees(data.student_fees)"
                :key="studentFee.id"
              >
                <th>{{ studentFee.fee_setting.fee.name }}</th>
                <td class="font-weight-bold">₹ {{ studentFee.amount }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fine == null ? 0 : studentFee.fine}}</td>
                <td class="font-weight-bold">₹ {{ studentFee.discount_amount == null ? 0 : studentFee.discount_amount}}</td>
                <td class="font-weight-bold">{{ studentFee.discount_percentage == null ? 0 : studentFee.discount_percentage}} %</td>
                <td class="font-weight-bold">₹ {{ studentFee.due_amount }}</td>
                <td class="font-weight-bold">{{ getFeeType(studentFee.fee_type) }}</td>
                <td class="font-weight-bold">₹ {{ studentFee.fee_total }}</td>
                <!-- <td class="text-primary">{{ moment(studentFee.start_date).format(dateFormat) }}</td> -->
                <td class="text-danger">{{ studentFee.due_date ? moment(studentFee.due_date).format(dateFormat): null }}</td>
                <td class="font-weight-bold">{{ studentFee.payment_status ? 'Paid' : 'Not Paid' }}</td>
                <td class="text-right">
                  <a
                    href="javascript:;"
                    :class="['p-1 mr-2 text-primary neo-icon-btn', `${studentFee.payment_status ? 'bg-light text-muted' : ''}`]"
                    @click="handlePaySingle(studentFee, schoolId, studentCode)"
                    :disabled="studentFee.payment_status === 1"
                  >
                    <i class="fe fe-credit-card" /> Pay
                  </a>
                  <a
                    :disabled="studentFee.payment_status != 1"
                    href="javascript:;"
                    :class="['p-1 text-primary neo-icon-btn', `${studentFee.payment_status != 1 ? 'bg-light text-muted' : ''}`]"
                    @click="handleViewReceipt(studentFee, data)"
                  >
                    <i class="fe fe-eye mr-2" /> Receipt
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
          </vue-custom-scrollbar>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { find } from 'lodash'
import moment from 'moment'

import { feeTypes } from '@/services/globaldata'

import vueCustomScrollbar from 'vue-custom-scrollbar'

export default {
  name: 'ShowStudentFees',
  props: ['data', 'schoolId', 'studentCode'],
  components: {
    vueCustomScrollbar,
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  methods: {
    moment,
    getOneTimeFees(data) {
      const oneTime = data.filter(element => element.fee_type === 1)
      return oneTime
    },
    getRecurringFees(studentFees) {
      const recurring = studentFees.filter(studentFee => studentFee.fee_type !== 1 && studentFee.fee_setting.class_fee) // Select only class fees and not individual fees
      return recurring
    },
    getIndividualFees(studentFees) {
      const individualFees = studentFees.filter(studentFee => (studentFee.fee_setting.fee ? studentFee.fee_setting.fee.target_type === 3 : false)) // 3 => Individual fees
      return individualFees
    },
    getFeeType(type) {
      return find(this.feeTypes, { value: type }).name
    },
    handlePayAll(data, schoolId, studentCode) {
      this.$eventBus.$emit('openPublicPayStudentFeesModal', data, schoolId, studentCode, 'PAYALL')
    },
    handlePaySingle(studentFee, schoolId, studentCode) {
      let studentFeesArr = []
      studentFeesArr.push(studentFee)
      this.$eventBus.$emit('openPublicPayStudentFeesModal', studentFeesArr, schoolId, studentCode, 'PAYSINGLE')
    },
    handleViewReceipt(studentFee, data) {
      const student = {
        first_name: data.student.first_name,
        last_name: data.student.last_name,
        student_code: data.student_code,
        class_name: data.school_class.name,
        section_name: data.section ? data.section.name : 'NA',
        roll_no: data.roll_no,
        id: data.student.id,
      }
      this.$eventBus.$emit('openViewStudentFeeReceiptModal', studentFee, student)
    },
  },
}
</script>
